// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IIncidentUiType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class IncidentUiType implements IIncidentUiType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Abandoned Vehicle IncidentUiType
	**/
    get AbandonedVehicle(): IIncidentUiType {
        return this.FromId(1);
    }
    /**
		Returns Document Incomplete IncidentUiType
	**/
    get DocumentIncomplete(): IIncidentUiType {
        return this.FromId(2);
    }
    /**
		Returns Financial Responsibility IncidentUiType
	**/
    get FinancialResponsibility(): IIncidentUiType {
        return this.FromId(3);
    }
    /**
		Returns Mandatory Insurance IncidentUiType
	**/
    get MandatoryInsurance(): IIncidentUiType {
        return this.FromId(4);
    }
    /**
		Returns Ops Of Law Lien Vehicle IncidentUiType
	**/
    get OpsOfLawLienVehicle(): IIncidentUiType {
        return this.FromId(5);
    }
    /**
		Returns Ops Of Law Lien Customer IncidentUiType
	**/
    get OpsOfLawLienCustomer(): IIncidentUiType {
        return this.FromId(6);
    }
    /**
		Returns Tteap IncidentUiType
	**/
    get Tteap(): IIncidentUiType {
        return this.FromId(7);
    }
    /**
		Returns Fraud Vehicle IncidentUiType
	**/
    get FraudVehicle(): IIncidentUiType {
        return this.FromId(8);
    }
    /**
		Returns Fraud Customer IncidentUiType
	**/
    get FraudCustomer(): IIncidentUiType {
        return this.FromId(9);
    }
    /**
		Returns Abandoned VehicleFee IncidentUiType
	**/
    get AbandonedVehicleFee(): IIncidentUiType {
        return this.FromId(10);
    }
    /**
		Returns Nsf Penalty Due IncidentUiType
	**/
    get NsfPenaltyDue(): IIncidentUiType {
        return this.FromId(11);
    }
    /**
		Returns NSF Cancellation IncidentUiType
	**/
    get NSFCancellation(): IIncidentUiType {
        return this.FromId(12);
    }
    /**
		Returns Nonpayment Of Judgment IncidentUiType
	**/
    get NonpaymentOfJudgment(): IIncidentUiType {
        return this.FromId(13);
    }
    /**
		Returns Default Judgment IncidentUiType
	**/
    get DefaultJudgment(): IIncidentUiType {
        return this.FromId(14);
    }
    /**
		Returns Failure To Comply With CIID IncidentUiType
	**/
    get FailureToComplyWithCIID(): IIncidentUiType {
        return this.FromId(15);
    }
    /**
		Returns Financial Responsibility Court Ordered IncidentUiType
	**/
    get FinancialResponsibilityCourtOrdered(): IIncidentUiType {
        return this.FromId(16);
    }
    /**
		Returns Failed Vision Exam IncidentUiType
	**/
    get FailedVisionExam(): IIncidentUiType {
        return this.FromId(17);
    }
    /**
		Returns Common Incident IncidentUiType
	**/
    get CommonIncident(): IIncidentUiType {
        return this.FromId(18);
    }
    /**
		Returns Underage Incident IncidentUiType
	**/
    get UnderageIncident(): IIncidentUiType {
        return this.FromId(19);
    }
    /**
		Returns Law Enforcement Incident IncidentUiType
	**/
    get LawEnforcementIncident(): IIncidentUiType {
        return this.FromId(20);
    }
    /**
		Returns In State Conviction IncidentUiType
	**/
    get InStateConviction(): IIncidentUiType {
        return this.FromId(21);
    }
    /**
		Returns Out Of State Conviction IncidentUiType
	**/
    get OutOfStateConviction(): IIncidentUiType {
        return this.FromId(22);
    }
    /**
		Returns Medical Alert Type IncidentUiType
	**/
    get MedicalAlertType(): IIncidentUiType {
        return this.FromId(23);
    }
    /**
		Returns Out Of State Law Enforcement IncidentUiType
	**/
    get OutOfStateLawEnforcement(): IIncidentUiType {
        return this.FromId(24);
    }
    /**
		Returns Finance Collection IncidentUiType
	**/
    get FinanceCollection(): IIncidentUiType {
        return this.FromId(25);
    }
    /**
		Returns DL Admin IncidentUiType
	**/
    get DLAdmin(): IIncidentUiType {
        return this.FromId(26);
    }
    /**
		Returns MRP Incident IncidentUiType
	**/
    get MRPIncident(): IIncidentUiType {
        return this.FromId(27);
    }
    /**
		Returns Fraud Customer AAMVA IncidentUiType
	**/
    get FraudCustomerAAMVA(): IIncidentUiType {
        return this.FromId(28);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'AbandonedVehicle', displayValue: 'Abandoned Vehicle', description: 'Abandoned Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'DocumentIncomplete', displayValue: 'Document Incomplete', description: 'Document Incomplete', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'FinancialResponsibility', displayValue: 'Financial Responsibility', description: 'Financial Responsibility', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'MandatoryInsurance', displayValue: 'Mandatory Insurance', description: 'Mandatory Insurance', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'OpsOfLawLienVehicle', displayValue: 'Ops Of Law Lien Vehicle', description: 'Ops Of Law Lien Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'OpsOfLawLienCustomer', displayValue: 'Ops Of Law Lien Customer', description: 'Ops Of Law Lien Customer', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'Tteap', displayValue: 'Tteap', description: 'Tteap', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'FraudVehicle', displayValue: 'Fraud Vehicle', description: 'Fraud Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'FraudCustomer', displayValue: 'Fraud Customer', description: 'Fraud Customer', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'AbandonedVehicleFee', displayValue: 'Abandoned VehicleFee', description: 'Abandoned VehicleFee', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'NsfPenaltyDue', displayValue: 'Nsf Penalty Due', description: 'Nsf Penalty Due', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'NSFCancellation', displayValue: 'NSF Cancellation', description: 'NSF Cancellation', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'NonpaymentOfJudgment', displayValue: 'Nonpayment Of Judgment', description: 'Nonpayment Of Judgment', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'DefaultJudgment', displayValue: 'Default Judgment', description: 'Default Judgment', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'FailureToComplyWithCIID', displayValue: 'Failure To Comply With CIID', description: 'Failure To Comply With CIID', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'FinancialResponsibilityCourtOrdered', displayValue: 'Financial Responsibility Court Ordered', description: 'Financial Responsibility Court Ordered', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'FailedVisionExam', displayValue: 'Failed Vision Exam', description: 'Failed Vision Exam', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'CommonIncident', displayValue: 'Common Incident', description: 'Common Incident', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'UnderageIncident', displayValue: 'Underage Incident', description: 'Underage Incident', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'LawEnforcementIncident', displayValue: 'Law Enforcement Incident', description: 'Law Enforcement Incident', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'InStateConviction', displayValue: 'In State Conviction', description: 'In State Conviction', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: 'OutOfStateConviction', displayValue: 'Out Of State Conviction', description: 'Out Of State Conviction', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: 'MedicalAlertType', displayValue: 'Medical Alert Type', description: 'Medical Alert Type', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: 'OutOfStateLawEnforcement', displayValue: 'Out Of State Law Enforcement', description: 'Out Of State Law Enforcement', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, value: 'FinanceCollection', displayValue: 'Finance Collection', description: 'Finance Collection', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, value: 'DLAdmin', displayValue: 'DL Admin', description: 'DL Admin', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, value: 'MRPIncident', displayValue: 'MRP Incident', description: 'MRP Incident', sortOrder: 999999, active: true });
        this._dictionary.add('28', { id: 28, value: 'FraudCustomerAAMVA', displayValue: 'Fraud Customer AAMVA', description: 'Fraud Customer AAMVA', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IIncidentUiType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IIncidentUiType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IIncidentUiType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IIncidentUiType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IIncidentUiType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
